import type {ModalDialogElement} from '@primer/view-components/app/components/primer/alpha/modal_dialog'

const hiddenFormElements: HTMLInputElement[] = []

export function showCopilotModal(element: string) {
  const modal = document.getElementById(element) as ModalDialogElement | HTMLDialogElement
  if (modal instanceof HTMLDialogElement) {
    modal.showModal()
  } else if (modal) {
    modal.show()
  }
}

export function hideCopilotModal(element: string) {
  const modal = document.getElementById(element) as ModalDialogElement | HTMLDialogElement
  if (modal) {
    modal.close()
  }
}

export function addCopilotHiddenFormElement(form: HTMLFormElement, key: string, value: string) {
  const input = document.createElement('input')
  input.type = 'hidden'
  input.name = key
  input.value = value
  form.appendChild(input)
  hiddenFormElements.push(input)
}

export function removeHiddenFormElements() {
  for (const element of hiddenFormElements) {
    element.remove()
  }
}

export function handleCopilotAllCheckbox(checkbox: HTMLInputElement, count: number, total: number) {
  if (count === total) {
    checkbox.checked = true
    checkbox.indeterminate = false
  } else if (count === 0) {
    checkbox.checked = false
    checkbox.indeterminate = false
  } else {
    checkbox.indeterminate = true
  }
}
